
      var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon24Like = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 24,
  width: 25,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "22.1 14.4 76.8 92.4"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M52.5 106.8H39.917c-5.203.002-9.677-3.65-10.669-8.709l-4.662-16.679c-4.149-11.654-2.343-17.855-.093-21.008a9.391 9.391 0 0 1 7.839-4.018H42.64c-.53-4.21-.384-8.477.43-12.643 2.507-9.93 7.996-10.363 10.233-10.09 3.5.427 6.687 3.447 6.687 6.335a19.021 19.021 0 0 0 5.133 14.234c5.222 5.17 14.646 6.556 14.74 6.57a2.582 2.582 0 0 1 2.21 2.916c-.204 1.41-1.522 2.389-2.946 2.188-.457-.065-11.25-1.654-17.685-8.028a23.977 23.977 0 0 1-6.658-17.74 3.068 3.068 0 0 0-2.459-1.371c-1.663.066-3.234 2.398-4.203 6.237-1.328 5.258.028 13.465.042 13.548a2.56 2.56 0 0 1-.582 2.09 2.614 2.614 0 0 1-1.986.911H32.332a4.187 4.187 0 0 0-3.587 1.837c-1.019 1.428-2.981 5.883.78 16.397.02.057.038.115.055.173l4.715 16.87c.02.074.038.149.052.224.49 2.665 2.835 4.601 5.57 4.6H52.5c9.579 0 22.36-2.112 25.127-4.939a2.621 2.621 0 0 1 3.681-.057 2.561 2.561 0 0 1 .058 3.646c-5.2 5.311-23.03 6.506-28.867 6.506z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M78.754 106.8a2.652 2.652 0 0 1-2.654-2.65v-45.1a2.652 2.652 0 0 1 2.654-2.65h17.491a2.652 2.652 0 0 1 2.655 2.65v45.1a2.652 2.652 0 0 1-2.655 2.65H78.754z",
  fill: "var(--theme-primary, #810ea9)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M82.1 100.8h12V62.4h-12v38.4zm-30-74.4c-1.326 0-2.4-1.113-2.4-2.486v-7.028c0-1.373 1.074-2.486 2.4-2.486 1.325 0 2.4 1.113 2.4 2.486v7.028c0 1.373-1.075 2.486-2.4 2.486zm13.236 8.4a2.432 2.432 0 0 1-2.347-1.774 2.418 2.418 0 0 1 1.09-2.725l5.897-3.533a2.443 2.443 0 0 1 2.456-.072 2.422 2.422 0 0 1 1.267 2.096 2.42 2.42 0 0 1-1.213 2.127l-5.897 3.534a2.435 2.435 0 0 1-1.253.347zm-27.688 0c-.444 0-.88-.121-1.26-.35l-5.934-3.55a2.426 2.426 0 0 1-.803-3.32 2.457 2.457 0 0 1 3.328-.85l5.934 3.55a2.428 2.428 0 0 1 1.097 2.738 2.447 2.447 0 0 1-2.362 1.782z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg height=\"24\" width=\"25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"22.1 14.4 76.8 92.4\">     <path d=\"M52.5 106.8H39.917c-5.203.002-9.677-3.65-10.669-8.709l-4.662-16.679c-4.149-11.654-2.343-17.855-.093-21.008a9.391 9.391 0 0 1 7.839-4.018H42.64c-.53-4.21-.384-8.477.43-12.643 2.507-9.93 7.996-10.363 10.233-10.09 3.5.427 6.687 3.447 6.687 6.335a19.021 19.021 0 0 0 5.133 14.234c5.222 5.17 14.646 6.556 14.74 6.57 1.423.2 2.412 1.506 2.21 2.916-.204 1.41-1.522 2.389-2.946 2.188-.457-.065-11.25-1.654-17.685-8.028a23.977 23.977 0 0 1-6.658-17.74 3.068 3.068 0 0 0-2.459-1.371c-1.663.066-3.234 2.398-4.203 6.237-1.328 5.258.028 13.465.042 13.548a2.56 2.56 0 0 1-.582 2.09 2.614 2.614 0 0 1-1.986.911H32.332a4.187 4.187 0 0 0-3.587 1.837c-1.019 1.428-2.981 5.883.78 16.397.02.057.038.115.055.173l4.715 16.87c.02.074.038.149.052.224.49 2.665 2.835 4.601 5.57 4.6H52.5c9.579 0 22.36-2.112 25.127-4.939a2.621 2.621 0 0 1 3.681-.057 2.561 2.561 0 0 1 .058 3.646c-5.2 5.311-23.03 6.506-28.867 6.506z\" fill=\"#000000\"></path>     <path d=\"M78.754 106.8a2.652 2.652 0 0 1-2.654-2.65v-45.1a2.652 2.652 0 0 1 2.654-2.65h17.491a2.652 2.652 0 0 1 2.655 2.65v45.1a2.652 2.652 0 0 1-2.655 2.65H78.754z\" fill=\"var(--theme-primary, #810ea9)\"></path>     <path d=\"M82.1 100.8h12V62.4h-12v38.4zM52.1 26.4c-1.326 0-2.4-1.113-2.4-2.486v-7.028c0-1.373 1.074-2.486 2.4-2.486 1.325 0 2.4 1.113 2.4 2.486v7.028c0 1.373-1.075 2.486-2.4 2.486zM65.336 34.8a2.432 2.432 0 0 1-2.347-1.774 2.418 2.418 0 0 1 1.09-2.725l5.897-3.533a2.443 2.443 0 0 1 2.456-.072 2.422 2.422 0 0 1 1.267 2.096 2.42 2.42 0 0 1-1.213 2.127l-5.897 3.534a2.435 2.435 0 0 1-1.253.347zM37.648 34.8c-.444 0-.88-.121-1.26-.35l-5.934-3.55a2.426 2.426 0 0 1-.803-3.32 2.457 2.457 0 0 1 3.328-.85l5.934 3.55a2.428 2.428 0 0 1 1.097 2.738 2.447 2.447 0 0 1-2.362 1.782z\" fill=\"var(--theme-primary, #810ea9)\"></path>    </svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-24-like.ce31b51ca10f40afbff6ec83ffdf0f0e.svg"),
        {
          React: SvgIcon24Like,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      